/*
 * Public API Surface of ngkit-search
 */

export * from './components/ngkit-search.component';
export * from './interfaces/ngkit-search-item';
